export default class PopUpMessage {
  static readonly LOADING_PRODUCTS_PROBLEM = new PopUpMessage('Gelieve opnieuw te proberen.')
  static readonly LOADING_CATEGORIES_PROBLEM = new PopUpMessage('Gelieve opnieuw te proberen.')
  static readonly LOADING_PRODUCT_PROPERTIES_PROBLEM = new PopUpMessage('Gelieve opnieuw te proberen.')
  static readonly COLOR_NOT_FOUND = new PopUpMessage('De gekozen kleur is niet beschikbaar voor je producten...')

  private constructor(public message: string) {
  }
}
